if($('footer#footer').length){
    if($('.in-index').length){
        $('#footer#footer').before($('footer#footer .realizations'))
        
    }
    $('#footer#footer').before($('footer#footer .customRatings'))
   

    $('footer#footer .needHelp ul').append($('footer#footer .contact-box span.mail').closest('li').clone())
    $('footer#footer .needHelp ul').append($('footer#footer .contact-box span.tel').closest('li').clone())
    $('footer#footer .customEmail').append($('footer#footer .contact-box span.mail a').clone())
    $('footer#footer .customTel').append($('footer#footer .contact-box span.tel a').clone())
    $('footer#footer .socialIcon').append($('footer#footer .contact-box span.facebook').closest('li').clone())
    $('footer#footer .socialIcon').append($('footer#footer .contact-box span.youtube').closest('li').clone())
    $('footer#footer .socialIcon').append($('footer#footer .contact-box span.instagram').closest('li').clone())
    $('#signature').prepend($('footer#footer .paymentLogos'))
    $('#signature').append('<span class="dostmedia"> | <a href="https://www.dostmedia.cz/" target="_blank">Dostmedia</a></span>')
    $(document).on('click', 'footer#footer h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });
    $(document).on('click', '.showModal', function(){
        $.colorbox({
            iframe: true,
            href: $(this).data('link'),
            width: "600px",
            maxWidth: "90%",
            height: 600,
            maxHeight: "90%",
            className: "iframeMap",
            onComplete: function() {
                
            },
        });
    });
}

$(document).ready(function() {
    var storedData = sessionStorage.getItem('ratingDataSauny');
    if (storedData) {
        $('.customRatings .ratingFeed').html(storedData);
    } else {
        $.ajax({
            url: '/hodnoceni-obchodu/',
            type: 'GET',
            success: function(response) {
                var content = $(response);
                var ratingsFinal = content.find('.votes-wrap').html();
                $('.customRatings .ratingFeed').html(ratingsFinal)

                sessionStorage.setItem('ratingDataSauny', ratingsFinal);
            },
            error: function(xhr, status, error) {
                console.error("Error fetching rating data:", status, error);
            }
        });
    }
});